import { AdminActionTypes, AdminActions } from "./admin.actions";
import { IUser } from "@common/models";
export interface IAdminState {
  totalUsers: number;
  users: IUser[];
}
const defaultState = { totalUsers: 0, users: [] };

export default function(
  state: IAdminState = defaultState,
  action: AdminActionTypes
) {
  if (action.payload instanceof Error) {
    return state;
  }

  switch (action.type) {
    case AdminActions.GET_USERS_RESPONSE: {
      const { totalUsers, users } = action.payload;
      return {
        totalUsers,
        users
      };
    }
    case AdminActions.USER_UPDATE_RESPNOSE: {
      const { userId } = action.payload;
      return {
        ...state,
        users: state.users.map(
          user => (user.userId === userId ? action.payload : user)
        )
      };
    }
    default:
      return state;
  }
}
